import React from 'react';
import { BubbleFormGroup, BubbleInput } from '@go-client/components/BubbleUI';
import { CallToActions } from '@go-client/components/BasicForms/CallToActions';
import { CallToActionsInstance, DailyProgramCta } from '@go-shared/types/dailyProgram';

interface CallToActionsManagementProps {
  sourceCtas: CallToActionsInstance;
  parentCtas: DailyProgramCta[];
  onUpdate: (cta: CallToActionsInstance) => void;
}

export const CallToActionsManagement: React.FC<CallToActionsManagementProps> = (
  props: CallToActionsManagementProps
) => {
  const { sourceCtas, parentCtas, onUpdate } = props;
  const callToActions = sourceCtas.syncWithTemplate ? parentCtas : sourceCtas.values;

  const handleCtaUpdates = (formCtas: DailyProgramCta[]) => {
    const syncWithTemplate = JSON.stringify(formCtas) === JSON.stringify(parentCtas)
    onUpdate({ syncWithTemplate, values: formCtas });
  };
  return (
    <fieldset>
      <BubbleFormGroup className="mb-5" label="Call to Actions">
        <div className="flex items-center mb-3 relative">
          <BubbleInput
            type="checkbox"
            inputClassName="stretched-link"
            checked={sourceCtas?.syncWithTemplate ?? true}
            onValue={chk => {
              onUpdate({
                syncWithTemplate: chk,
                values: sourceCtas.values,
              });
            }}
          />
          <span className="ml-1">Default to Library</span>
        </div>

        <CallToActions callToActions={callToActions} onUpdate={handleCtaUpdates} />
      </BubbleFormGroup>
    </fieldset >
  );
};
